import {closeAlert, receiveSuccessAlert} from "../commonsActions";
import {saveLoanBankProperty, updateLoanBankProperty} from "../../helpers/loanBankPropertyService";

export const saveSingleLoanBankProperty = property => dispatch => {
    return saveLoanBankProperty(property).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const updateSingleLoanBankProperty = property => dispatch => {
    return updateLoanBankProperty(property).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};


// WEBPACK FOOTER //
// ./src/actions/loan/loanBankPropertyAction.js